import { leafletToMapboxGeoFenceStyle } from 'frontend/live-panel/helpers/leaflet-to-mapbox-adapters'
import {ThemeType} from 'frontend/themes/enum/theme-type'

export function getMapZoneGeoFenceStyle(themeType: ThemeType) {
  const textColor = {
    [ThemeType.Light]: '#7d4e0c',
    [ThemeType.Dark]: '#ffe400',
  }[themeType]

  const mapZoneGeoFenceStyle = {
    fillColor: '#ffe400',
    fillOpacity: 0.15,
    strokeColor: '#ffe400',
    strokeWidth: 1,
    strokeOpacity: 0.8,
    textColor,
  }
  return leafletToMapboxGeoFenceStyle(mapZoneGeoFenceStyle)
}